import { CONTACT_LINKS } from '../data';

export default function Contact() {
  return (
    <section id="contact" className="lw-section lw-contact">
      <h2 className="lw-contact__title">같이 만들어요.</h2>
      <p className="lw-contact__sub">협업 제안, 투자 문의, 그냥 안녕도 환영해요.</p>

      <div className="lw-contact__links">
        {CONTACT_LINKS.map((l) => (
          <a
            className="lw-link"
            key={l.href}
            href={l.href}
            target={l.href.startsWith('http') ? '_blank' : undefined}
            rel={l.href.startsWith('http') ? 'noreferrer' : undefined}
          >
            {l.label}
          </a>
        ))}
      </div>

      <div className="lw-footer">
        <span>© 2026 LittleWins · 곽지은</span>
      </div>
    </section>
  );
}
